import $ from "jquery";

const actions = (element, index) => {
  const $menu = element.parent().children(".post-card__post-actions");

  element.off("click");
  element.on("click", function (event) {
    event.stopPropagation();
    toggleMenu($menu);
  });

};

const toggleMenu = ($menu) =>
  $menu.hasClass("post-card__post-actions--active")
    ? hideMenu($menu)
    : showMenu($menu);

const showMenu = ($menu) => {
  hideMenu($(".post-card__post-actions"));
  $menu.addClass("post-card__post-actions--active");
};

const hideMenu = ($menu) =>
  $menu.removeClass("post-card__post-actions--active");


export const reloadScriptPostActions = () => {
  const $actions = $(".post-card__post-actions-button");

  $actions.each(function (index) {
    actions($(this), index);
  });
};
reloadScriptPostActions();
